import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';

import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { TupAuthModule } from '@telmar-global/tup-auth';
import { environment } from 'src/environments/environment';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TupMaterialModule } from '@telmar-global/tup-material';
import { MaterialModule } from './modules/material.module';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { HomeComponent } from './pages/home/home.component';
import { OpenapiRenderComponent } from './openapi-render/openapi-render.component';
import { RouteReuseStrategy } from '@angular/router';
import { AppRouteReuseStrategy } from './modules/route-reuse-strategy';
import { HowToUseApisComponent } from './pages/how-to-use-apis/how-to-use-apis.component';
import { ApiTutorialRendererComponent } from './pages/api-tutorial/api-tutorial.component';
import { ApiListItemsComponent } from './components/api-list-items/api-list-items.component';
import { ApiLinkCardComponent } from './components/api-list-items/api-link-card/api-link-card.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    PageNotFoundComponent,
    HomeComponent,
    OpenapiRenderComponent,
    HowToUseApisComponent,
    ApiTutorialRendererComponent,
    ApiListItemsComponent,
    ApiLinkCardComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    TupMaterialModule,
    MaterialModule,
    HttpClientModule,
    MarkdownModule.forRoot({ loader: HttpClient }),

    TupAuthModule.forRoot( environment, routes ),

  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: AppRouteReuseStrategy,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
